module.exports = __webpack_public_path__ + "static/img/4.b313e00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/4.png
// module id = KVBy
// module chunks = 1